import { useState, useEffect, PropsWithChildren, ReactElement } from 'react';
import styled from 'styled-components';

const Container = styled.div`
	display: flex;
`;

const Digit = styled.div`
	position: relative;
	line-height: 1;
`;

const RealNumber = styled.div`
	opacity: 0;
`;

const VirtualDigit = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	overflow: hidden;
`;

const VirtualNumber = styled.div<{ number: number }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	transform: translate3d(0, -${({ number }) => number * 10}%, 0);
	transition: transform 2s ease-in-out;
`;

interface TournamentCardCounterProps {
	number: number;
	NumberWrapper: (props: PropsWithChildren) => ReactElement | null;
}

export default function TournamentCardCounter({ number, NumberWrapper }: TournamentCardCounterProps) {
	const [decidedNumber, setDecidedNumber] = useState('0'.repeat(String(number).length));
	const digits = decidedNumber.split('');

	useEffect(() => {
		setDecidedNumber(String(number));
	}, [number]);

	return (
		<Container>
			{digits.map((digit, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<Digit key={index}>
					<RealNumber>
						<NumberWrapper>{digit}</NumberWrapper>
					</RealNumber>

					<VirtualDigit>
						<VirtualNumber number={Number(digit)}>
							<NumberWrapper>0</NumberWrapper>
							<NumberWrapper>1</NumberWrapper>
							<NumberWrapper>2</NumberWrapper>
							<NumberWrapper>3</NumberWrapper>
							<NumberWrapper>4</NumberWrapper>
							<NumberWrapper>5</NumberWrapper>
							<NumberWrapper>6</NumberWrapper>
							<NumberWrapper>7</NumberWrapper>
							<NumberWrapper>8</NumberWrapper>
							<NumberWrapper>9</NumberWrapper>
						</VirtualNumber>
					</VirtualDigit>
				</Digit>
			))}
		</Container>
	);
}
